export default "__VITE_ASSET__JwvzfEMy__"